// extracted by mini-css-extract-plugin
export default {"container":"QlShr","mobileReactions":"_8mDfT"};